<template>
  <el-dialog
    title="合并线索"
    :visible.sync="dialogVisible"
    width="50%"
    class="mergingClueDialog"
    @close="dialogCloseHandle"
  >
    <!-- <div class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
          <div class="label">主线索ID</div>
          <div class="content">
            <el-select v-model="mainId" clearable placeholder="请选择">
              <el-option
                v-for="item in tableList"
                :key="item.leadId"
                :label="item.leadId"
                :value="item.leadId"
              />
            </el-select>
          </div>
        </el-col>
      </el-row>
    </div>
    <commonTable ref="mergingClueTable" />
  </div> -->
    <el-form label-position="left" ref="qdApplyOrderForm" label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="主线索ID">
            <el-select v-model="mainId" clearable placeholder="请选择">
              <el-option
                v-for="item in tableList"
                :key="item.leadId"
                :label="item.leadId"
                :value="item.leadId"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <commonTable ref="mergingClueTable" />
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import commonTable from '@/components/commonTable';
  import { TableColumns, TableRow } from '@/utils/tableOptions';
  import { waitingProcessingApi } from '../../service';
  export default {
    data () {
      return {
        dialogVisible: false,
        mainId: '',
        expensesTypeList: [],
        tableList: []
      };
    },
    props: {
      mergingClueShow: {
        type: Boolean,
        default: false
      },
      leadId: {
        type: String,
        default: ''
      }
    },
    watch: {
      mergingClueShow (val) {
        if (val) {
          this.getRepeatList();
        } else {
          this.mainId = '';
          this.tableList = [];
          this.loadTable();
        }
        this.dialogVisible = val;
      }
    },
    components: {
      commonTable
    },
    methods: {
      getRepeatList () {
        this.$nextTick(() => {
          this.$refs.mergingClueTable.loading = true;
        });
        waitingProcessingApi.getRepeatList(this.leadId).then(res => {
          if (res.status === '200') {
            this.tableList = res.data;
            this.loadTable();
          }
          this.$refs.mergingClueTable.loading = false;
          this.$store.commit('setSubPageLoading', false);
        });
      },
      submitHandlen () {
        if (this.mainId) {
          let params = {
            leadId: this.mainId
          };
          params.leadIdList = this.tableList.map(item => {
            return item.leadId;
          });
          this.$emit('submitHandle', params);
        } else {
          this.$message.error('请选择主线索ID');
        }
      },
      dialogCloseHandle () {
        this.$emit('dialogCloseHandle');
      },
      deleteHandle (row) {
        this.$confirm('确定删除该线索？', '线索删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$refs.mergingClueTable.loading = true;
          this.$refs.mergingClueTable.removeRow(row);
          this.$refs.mergingClueTable.loading = false;
          // this.$refs.mergingClueTable.loading = true;
          // waitingProcessingApi.leadDelete(row.leadId).then(res => {
          //   if (res.status === '200') {
          //     this.$message.success('删除成功');
          //     this.$emit('deleteHandle');
          //     this.getRepeatList();
          //   } else {
          //     this.$refs.mergingClueTable.loading = false;
          //   }
          // });
        }).catch(() => {
        });
      },
      loadTable () {
        let tableRow = new TableRow();
        tableRow.push(
          new TableColumns()
            ._title('序号')
            ._width('5%')
            ._others('seq')
        );
        tableRow.push(
          new TableColumns()
            ._title('线索ID')
            ._width('8%')
            ._data('leadId')
        );
        tableRow.push(
          new TableColumns()
            ._title('客户单位')
            ._width('8%')
            ._data('unit')
        );
        tableRow.push(
          new TableColumns()
            ._title('客户姓名')
            ._width('8%')
            ._data('name')
        );
        tableRow.push(
          new TableColumns()
            ._title('产品线')
            ._width('8%')
            ._data('productLine')
        );
        tableRow.push(
          new TableColumns()
            ._title('线索名称')
            ._width('8%')
            ._data('leadName')
        );
        tableRow.push(
          new TableColumns()
            ._title('操作')
            ._width('12%')
            ._fixed('right')
            ._cellType('customDom')
            ._cellData({
              formater: ({ row }) => {
                return (
                  <div>
                    {
                      this.tableList.length !== 1 ? (
                        <el-button type="text" onClick={() => { this.deleteHandle(row); }}>删除</el-button>
                      ) : null
                    }
                  </div>
                );
              }
            })
        );
        let column = tableRow._cols();
        this.$nextTick(() => {
          this.$refs.mergingClueTable.setColumn(column, {
            page: false
          });
          this.$refs.mergingClueTable.loadStaticTable(this.tableList);
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .mergingClueDialog{
    ::v-deep>.el-dialog{
      min-width: 620px;
    }
  }
</style>
